import { Toaster } from 'react-hot-toast';
import AkBackendCard from './Overview/AkBackendCard';
import AkCloneCard from './Overview/AkCloneCard';
import AkResourcesCard from './Overview/AkResourcesCard';
import KctGeneralCard from './Overview/KctGeneralCard';

export default function OverviewPage() {
  return (
    <section className="space-y-3">
      <Toaster position="top-right" toastOptions={{ duration: 2500 }} />

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <AkBackendCard />
        <AkCloneCard />
        <AkResourcesCard />
        <KctGeneralCard />
      </div>
    </section>
  );
}
